export default "__VITE_ASSET__fc4515ee__"